import { IconManifest } from 'app/agriculture/icons/types';
import { MapIconOptions } from 'app/agriculture/icons/utils/map-icon-utils/types';
import { BillboardIcon } from 'app/agriculture/icons/utils/map-icon-utils/BillboardIcon';

interface OverlayIconProps extends MapIconOptions {
    icon: IconManifest;
}

export function OverlayIcon({ icon, overlayColor = '#fff' }: OverlayIconProps) {
    return `
        <svg xmlns="http://www.w3.org/2000/svg" width="128" height="128" viewBox="16 16 96 96">
            ${BillboardIcon({ icon, iconColor: overlayColor })}
        </svg>
    `;
}
